import React, { useMemo, ReactNode, createContext, useContext } from "react";

import { AppEndpointAddonMasterRaw } from "@/domain/AppEndpointAddonMaster";
import { useEndpointAddonMastersAPI } from "../hooks";

/**
 * 組織内 (非管理者ルート) でEndpoint Addonマスタ一覧を提供するプロバイダ。
 *
 * Connectマスタと同様、組織内ではその組織に割り当て済みのマスタのみを扱う。
 * 割り当ての管理は管理者ルートで行い、組織内では行わない。
 * 取得は org-scoped API (getAdminEndpointAddonMasters) を用いる。
 * 当該 API は aa:developer 以上のみ利用可能なため、権限がない場合や
 * organizationId がない場合は一覧を取得しない。
 */
const ctx = createContext<{
  endpointAddonMasters: AppEndpointAddonMasterRaw[] | null;
  runReloadEndpointAddonMasters: () => Promise<void>;
  isLoadedEndpointAddonMasters: boolean;
}>({
  endpointAddonMasters: null,
  runReloadEndpointAddonMasters: async () => {},
  isLoadedEndpointAddonMasters: false,
});

export const EndpointAddonMastersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: endpointAddonMasters,
    runReloadState: runReloadEndpointAddonMasters,
    isLoadedState: isLoadedEndpointAddonMasters,
  } = useEndpointAddonMastersAPI();

  const ctxValue = useMemo(
    () => ({
      endpointAddonMasters,
      runReloadEndpointAddonMasters,
      isLoadedEndpointAddonMasters,
    }),
    [
      endpointAddonMasters,
      runReloadEndpointAddonMasters,
      isLoadedEndpointAddonMasters,
    ]
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useEndpointAddonMasters = () => {
  return useContext(ctx);
};
